module.exports = __webpack_public_path__ + "static/media/img-company-success-1-mobile@2x.2bdc51ec.png";